<template>
  <vbutton :label="label" :disabled="disabled" @click="submit" />
</template>

<script>
  export default {
    name: 'SendButton',

    props: {
      disabled: Boolean,
      label: String,
      isEmitClick: Boolean
    },

    methods: {
      submit() {
        if (!this.isEmitClick) {
          this.sendInvites();
        }
        this.$emit('send-invites');
      },

      async sendInvites() {
        try {
          await this.$store.dispatch('invites/creation/sendInvitesCheck');
        } catch (e) {
          this.$noty.error(this.$tr(e.message));
        }
      }
    }
  };
</script>
